import React, { FC, PropsWithChildren } from "react";

import { useAuth } from "@/shared/hooks";
import { Scope } from "@/shared/hooks/useAuth/types";

interface HiddenOnScopeProps {
    allowedScopes?: Scope[];
}

const HiddenOnScope: FC<PropsWithChildren<HiddenOnScopeProps>> = ({ allowedScopes = [], children }) => {
    const {
        scopeOptions: { onlyAllowedRoutes },
        user: { scope },
    } = useAuth();

    if (onlyAllowedRoutes && !allowedScopes.includes(scope)) {
        return <></>;
    }

    return <>{children}</>;
};

export default HiddenOnScope;
